/**
 * Krytí černého ztmavení pod bílým textem přes fotku (vize podnety-tymu-2026-10, F8.5) —
 * JEDINÝ zdroj čísel. Čte je web (`apps/web/src/lib/heroScrim.ts` je re-exportuje pro
 * drobeček i sdílené ztmavení hero), admin (náhled hero v detailu fotky) a měřidlo
 * `scripts/kontrola/hero-kontrast.mjs`.
 *
 * Řádek `export const HERO_TEXT_MIN_OPACITY = <číslo>;` drž doslova v tomto tvaru: měřidlo ho
 * čte z textu souboru, protože ze `scripts/` nejde importovat `@ckgo2/shared`.
 *
 * Výpočet WCAG nad nejhorším podkladem (bílá plocha): bílý text s krytím 0,9 pod vrstvou
 * 0,5 dá 3,56:1 (velký text, mez 3:1), pod vrstvou 0,6 dá 5,02:1 (ostatní text, mez 4,5:1).
 */

export type HeroScrimLevel = "nadpis" | "text";

/**
 * Drobeček (vize G2): přesun z apps/web/src/lib/heroScrim.ts, hodnota beze změny.
 * Minimální krytí v pásmu textu; mez WCAG je ≈ 0,535 (4,5:1 nad bílou), 0,6 dává rezervu.
 */
export const HERO_SCRIM_MIN_ALPHA = 0.6;

/** Krytí pod velkým textem (nadpis hero): mez WCAG 3:1 i s průhledností textu 0,9. */
export const HERO_SCRIM_HEADING_ALPHA = 0.5;

/** Krytí ztmavení podle úrovně textu oblasti. */
export const HERO_SCRIM_ALPHA: Readonly<Record<HeroScrimLevel, number>> = {
  nadpis: HERO_SCRIM_HEADING_ALPHA,
  text: HERO_SCRIM_MIN_ALPHA,
};

/** Nejnižší krytí bílého textu v hero oblasti (`text-white/N`: N/100 ≥ tato hodnota). */
export const HERO_TEXT_MIN_OPACITY = 0.9;
